import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=5fae14be&scoped=true&lang=pug&"
import script from "./Type.vue?vue&type=script&lang=ts&"
export * from "./Type.vue?vue&type=script&lang=ts&"
import style0 from "./Type.vue?vue&type=style&index=0&id=5fae14be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae14be",
  null
  
)

export default component.exports